/**
 * Context is a container for the current state of the workflow.
 * It is passed to each step in the workflow.
 * It is used to store state and manage `onComplete` events.
 */
var Context = /** @class */ (function () {
    function Context(sessionManager, metadata, events) {
        var _this = this;
        this.sessionManager = sessionManager;
        this.metadata = metadata;
        this.events = events;
        this.identity = this.sessionManager.getSessionIdentity();
        this.sessionManager.onChanged.subscribe(function (_, ev) {
            if (ev.property === 'identity') {
                _this.identity = ev.value;
            }
        });
    }
    Context.prototype.clone = function (events) {
        var clone = new Context(this.sessionManager, this.metadata, events || this.events);
        return clone;
    };
    return Context;
}());
export { Context };
//# sourceMappingURL=Context.js.map